import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import ZooHarmonyNFTLikes from '../../abis/ZooHarmonyNFTLikes.json'
import ZooHarmonyNFT from '../../abis/ZooHarmonyNFT.json'
import Img from 'react-cool-img'
import ReactPlaceholder from 'react-placeholder'
import { toast } from 'react-toastify'
import LazyLoad, { forceCheck } from 'react-lazyload'
import Fuse from 'fuse.js'
import Web3 from 'web3'
import 'react-placeholder/lib/reactPlaceholder.css'
import 'react-sweet-progress/lib/style.css'

function NSFW() {
  const [images, setData] = useState([])
  const [ready, setReady] = useState(false)
  const [totalSupply, setTotal] = useState(0)
  const [loaded, setLoad] = useState(false)
  const [toggle, setToggle] = useState()
  const [offset, setOffset] = useState(0)

  const [currentPage, setcurrentPage] = useState(0)
  const [pageCount, setPageCount] = useState(1)
  const [perPage, setPerPage] = useState(12)

  async function getNFTs() {

    const web3 = new Web3('https://matic-mumbai.chainstacklabs.com')
    // Load account
    // const accounts = await web3.eth.getAccounts()
    // this.setState({ account: accounts[0] })

    const networkId = 80001
    const networkData = ZooHarmonyNFT.networks[networkId]
    if (networkData) {
      const abi = ZooHarmonyNFT.abi
      const address = networkData.address
      const contract = new web3.eth.Contract(abi, address)
      // console.log(contract)

      const totalSupply = await contract.methods.totalSupply().call()
      // console.log(totalSupply)
      setTotal(totalSupply)

      const abilike = ZooHarmonyNFTLikes.abi
      const contractlike = new web3.eth.Contract(abilike, '0x0577e2163cccE36a83b658e682Abd7643b16EfE0')

      const abiblack = [{"stateMutability":"nonpayable","type":"constructor","inputs":[]},{"type":"event","name":"SetBlackListedAddress","inputs":[{"internalType":"address","indexed":true,"name":"hashAddress","type":"address"},{"name":"blacklisted","type":"bool","indexed":false,"internalType":"bool"}],"anonymous":false},{"inputs":[{"name":"nftID","indexed":true,"type":"uint256","internalType":"uint256"},{"name":"blacklisted","type":"bool","indexed":false,"internalType":"bool"}],"name":"SetBlackListedNFT","anonymous":false,"type":"event"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"idupdates","type":"function","outputs":[{"name":"","type":"uint256","internalType":"uint256"}],"stateMutability":"view"},{"inputs":[],"name":"owner","stateMutability":"view","type":"function","outputs":[{"internalType":"address","type":"address","name":""}]},{"type":"function","outputs":[{"type":"address","name":"","internalType":"address"}],"stateMutability":"view","name":"updates","inputs":[{"type":"uint256","internalType":"uint256","name":""}]},{"outputs":[],"stateMutability":"nonpayable","inputs":[{"internalType":"address","name":"addy","type":"address"},{"internalType":"bool","name":"blacklisted","type":"bool"}],"type":"function","name":"setBlackListedAddress"},{"inputs":[{"internalType":"uint256","name":"nftID","type":"uint256"},{"internalType":"bool","name":"blacklisted","type":"bool"}],"name":"setBlackListedNFT","outputs":[],"type":"function","stateMutability":"nonpayable"},{"outputs":[{"type":"bool","internalType":"bool","name":""}],"stateMutability":"view","name":"getBlackListedAddress","inputs":[{"name":"blAddress","internalType":"address","type":"address"}],"type":"function"},{"type":"function","name":"getBlackListedNFT","inputs":[{"name":"nftID","type":"uint256","internalType":"uint256"}],"stateMutability":"view","outputs":[{"internalType":"bool","type":"bool","name":""}]},{"stateMutability":"view","name":"AddyCount","type":"function","outputs":[{"type":"uint256","name":"","internalType":"uint256"}],"inputs":[]},{"outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"type":"function","inputs":[],"name":"IDCount","stateMutability":"view"}]      

      const contractblack = new web3.eth.Contract(abiblack, '0x52533B602Fa9ffed7BaA276154d5295F4B1B633B')

      fetch('https://matic-rpc.zoo-harmony.com/matic/polygon.json', {
        mode: 'cors',
      })
        .then(response => {
          // console.log(response)
          return response.json()
        })
        .then(data => {
          // Work with JSON data here
          // console.log(data);
          // console.log(data.length)
          setTotal(data.length)
          // const slice = data.slice(offset, offset + perPage);
          // setData(slice);
          const fuse = new Fuse(data, {
            keys: ['category'],
          })

          var matches = []

          const result = fuse.search('=NSFW$')
          if (!result.length) {
            setData([])
            // setData(images);
          } else {
            result.forEach(({ item }) => {
              matches.push(item)
            })
            // setData([]);
            setData(matches)
            forceCheck()
            // console.log(matches);
            //   setData(matches);
          }
          // setData(data);
          setPageCount(Math.ceil(images.length / perPage))
          setReady(true)
        })
        .catch(err => {
          // Do something for an error here
          // console.log('Error Reading data ' + err)
        })
    
    } else {
      toast.error("Switch to Harmony Mainnet!")
    }
  }

  useEffect(() => {
    getNFTs()
  }, [])

  const handlePageChange = e => {
    setcurrentPage(e.selected)
    const offset = Math.ceil(e.selected * perPage)
    setOffset(offset)
    // console.log(currentPage)
    // console.log(offset)
    getNFTs()
  }

  const searchData = pattern => {
    var matches = []

    if (!pattern) {
      setData([])
      setReady(false)
      getNFTs()
      //   matches = [];
      //   getNFTs();
      // setData(images);
      return
    }

    const fuse = new Fuse(images, {
      keys: ['name', 'category'],
    })

    const result = fuse.search(pattern)
    if (!result.length) {
      setData([])
      // setData(images);
    } else {
      result.forEach(({ item }) => {
        matches.push(item)
      })
      // setData([]);
      setData(matches)
      forceCheck()
      // console.log(matches);
      //   setData(matches);
    }
  }

  return (
    <div>
      <div className="head-title col-auto mx-4">
        <h4 className="mb-0 font-weight-normal">
          All <strong>{images.length}</strong> "NSFW" NFTs on ZooHarmony Harmony
        </h4>
      </div>
      <div className="container-fluid mb-5 explore-adj">
        <div className="row justify-content-around">
          <p align="center" className="text-secondary">
            This is where you can explore all "NSFW" category NFTs that were minted within ZooHarmonyNFT Market.
          </p>
          <p>
            <div align="center" style={{ maxWidth: '500px', margin: '0 auto' }}>
              <input
                placeholder="Search all 'NSFW' ZooHarmony NFTs..."
                type="text"
                className="form-control my-2"
                onChange={e => searchData(e.target.value)}
                disabled={loaded}
              ></input>
            </div>
          </p>
          <ReactPlaceholder
            type="rect"
            ready={ready}
            showLoadingAnimation={true}
            color="#333"
            style={{ width: '300px', height: '300px', borderRadius: '15px' }}
          >
            {images.map(key => (

              <div key={key.id} className="col-md-2 card bg-light m-3 p-2">
                <LazyLoad height={300}>
                  <div className="m-2 row" align="center">
                    <div className="col-6">
                      <span id={'count' + key.id}>{key.likecount}</span>{' '}
                      <i className="fab fa-gratipay like" id={'like' + key.id}></i>
                    </div>
                    <div className="col-6">
                      <span id={'counti' + key.id}>{key.icecount}</span>{' '}
                      <i className="fab fa-codiepie ice" id={'ice' + key.id}></i>
                    </div>
                  </div>
                  <Link
                    to={{
                      pathname: `/nft/${key.id}`,
                    }}
                  >
                    <form onSubmit={event => {}}>
                      <div className="col-auto max-250">
                        <div className="text-secondary idbadge" align="center">
                          ID #{key.id}
                        </div>
                        {typeof key.nftData !== 'undefined' ? (
                          key.mimeType === 'image/jpeg' ||
                          key.mimeType === 'image/png' ||
                          key.mimeType === 'image/gif' ? (
                            <Img
                              alt="NFT"
                              className="token rounded"
                              src={'https://zooharmony.mypinata.cloud/ipfs/' + key.nftData}
                              cache
                              style={{ background: '#21263e' }}
                            />
                          ) : key.mimeType === 'video/mp4' ? (
                            <video
                              alt="NFT"
                              className="token rounded"
                              autoPlay
                              playsInline
                              muted
                              loop
                              controls
                              src={'https://zooharmony.mypinata.cloud/ipfs/' + key.nftData}
                              type="video/mp4"
                            >
                              <source
                                src={'https://zooharmony.mypinata.cloud/ipfs/' + key.nftData}
                                type="video/mp4"
                              ></source>
                            </video>
                          ) : key.mimeType === 'model/gltf-binary' ? (
                            <model-viewer
                              src={'https://zooharmony.mypinata.cloud/ipfs/' + key.nftData}
                              alt={key.name}
                              ar
                              ar-modes="webxr scene-viewer quick-look"
                              environment-image="neutral"
                              auto-rotate
                              camera-controls
                              style={{ width: '100%', height: '250px' }}
                            ></model-viewer>
                          ) : null
                        ) : null}
                      </div>
                      <div className="m-2" align="center">
                        {key.name}
                      </div>
                    </form>
                  </Link>
                </LazyLoad>
              </div>
            ))}
          </ReactPlaceholder>
        </div>
      </div>
    </div>
  )
}


export default NSFW
